import { z } from "zod";

const CUBE_NAME = "CSOTag" as const;

export const costSavingOpportunityTagResultSchema = z.object({
  [`${CUBE_NAME}.date`]: z.string(),
  [`${CUBE_NAME}.dashboard_key`]: z.string().nullish(),
  [`${CUBE_NAME}.section_key`]: z.string().nullish(),
  [`${CUBE_NAME}.resource_key`]: z.string().nullish(),
  [`${CUBE_NAME}.resource_tag_key`]: z.string().nullish(),
  [`${CUBE_NAME}.resource_tag_value`]: z.string().nullish(),
  [`${CUBE_NAME}.first_match`]: z.string().nullish(),
  [`${CUBE_NAME}.percent`]: z.string().nullish(),
  [`${CUBE_NAME}.dailyListSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.dailyBilledSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.dailyEffectiveSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.monthlyListSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.monthlyBilledSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.monthlyEffectiveSavingOpportunity`]: z.string().nullish(),
  [`${CUBE_NAME}.nonCompliantResourceCount`]: z.string(),
  "Account.key": z.string().nullish(),
  "Account.name": z.string().nullish(),
  "Account.email": z.string().nullish(),
  "Account.groups": z.string().nullish(),
  "CloudRegion.region": z.string().nullish(),
});

export const costSavingOpportunityTagResultArraySchema = z
  .array(costSavingOpportunityTagResultSchema)
  .nullish();

export type CostSavingOpportunityTagResult = z.infer<
  typeof costSavingOpportunityTagResultSchema
>;
